module.exports = __webpack_public_path__ + "static/action-lab-9316561dd10a85ba4302707ba5b211ff.png";